// extracted by mini-css-extract-plugin
export default {"statsWrapper":"contestStats_statsWrapper__7A5YS"};